import { render } from "./PlanCollege.vue?vue&type=template&id=27e09b3f&scoped=true"
import script from "./PlanCollege.vue?vue&type=script&lang=js"
export * from "./PlanCollege.vue?vue&type=script&lang=js"

import "./PlanCollege.vue?vue&type=style&index=0&id=27e09b3f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-27e09b3f"

export default script